module.exports = __webpack_public_path__ + "static/img/tiao.a9ad821.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/6/tiao.png
// module id = IyrY
// module chunks = 0